<script lang="ts">
    import type { ArchivedPostTeaserFragment } from '$gen/graphql';
    import { fade } from 'svelte/transition';

    export let post: ArchivedPostTeaserFragment;
    // TODO: create a thumbnail for each post. Keep in mind that this is going to affect around 4000 images.

    $: img =
        post?.imagesArchive[0]?.image[0]?.__typename === 'archiveAssets_Asset'
            ? post?.imagesArchive[0]?.image[0]
            : null;

    let portrait: boolean;
    $: if (img) {
        portrait = img?.width > img?.height;
    }
</script>

<article
    class="object-cover"
    style:grid-column-end={portrait ? 'span 2' : 'span 1'}
    title={post.exhibitionTitle}
    id={post.id}
    transition:fade|local
>
    <a href={`${post.uri}`} sveltekit:prefetch>
        {#if img}
            <img
                class="h-full max-h-full w-full bg-red object-cover"
                src={img.url}
                alt={post.exhibitionTitle}
                width={img.width}
                height={img.height}
                loading="lazy"
            />
        {/if}
    </a>
</article>
